import * as React from "react";

const CirclePlus: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" focusable="false">
            <path fill="none" d="M-2-2h24v24H-2z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M10 0l.28.004C15.673.152 20 4.571 20 10l-.004.28C19.848 15.673 15.429 20 10 20 4.477 20 0 15.523 0 10S4.477 0 10 0zm0 2a8 8 0 000 16l.249-.004A8 8 0 0018 10l-.004-.249A8 8 0 0010 2zm0 4a1 1 0 011 1v2h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2H7a1 1 0 010-2h2V7a1 1 0 011-1z"
            />
        </svg>
    );
};

export const circlePlusStringDark =
    "PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgLjcwOEM1LjU1Ny43MDguMzMzIDUuOTMyLjMzMyAxMi4zNzVTNS41NTcgMjQuMDQyIDEyIDI0LjA0MnMxMS42NjctNS4yMjQgMTEuNjY3LTExLjY2N1MxOC40NDMuNzA4IDEyIC43MDh6bTMuNSAxMi44MzRoLTIuMzMzdjIuMzMzYTEuMTY3IDEuMTY3IDAgMTEtMi4zMzQgMHYtMi4zMzNIOC41YTEuMTY3IDEuMTY3IDAgMTEwLTIuMzM0aDIuMzMzVjguODc1YTEuMTY3IDEuMTY3IDAgMTEyLjMzNCAwdjIuMzMzSDE1LjVhMS4xNjcgMS4xNjcgMCAxMTAgMi4zMzR6IiBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";

export const circlePlusStringTransparent =
    "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PHBhdGggZmlsbD0ibm9uZSIgZD0iTS0yLTJoMjR2MjRILTJ6Ii8+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMTAgMGwuMjguMDA0QzE1LjY3My4xNTIgMjAgNC41NzEgMjAgMTBsLS4wMDQuMjhDMTkuODQ4IDE1LjY3MyAxNS40MjkgMjAgMTAgMjAgNC40NzcgMjAgMCAxNS41MjMgMCAxMFM0LjQ3NyAwIDEwIDB6bTAgMmE4IDggMCAwMDAgMTZsLjI0OS0uMDA0QTggOCAwIDAwMTggMTBsLS4wMDQtLjI0OUE4IDggMCAwMDEwIDJ6bTAgNGExIDEgMCAwMTEgMXYyaDJhMSAxIDAgMDEwIDJoLTJ2MmExIDEgMCAwMS0yIDB2LTJIN2ExIDEgMCAwMTAtMmgyVjdhMSAxIDAgMDExLTF6Ii8+PC9zdmc+";

export default React.memo(CirclePlus);
